import React from 'react';
import FormActionShape from '../../../lib/shapes/FormActionShape';

// Components
import UserRegistrationForm from './forms/UserRegistrationForm';

function UserRegistration({ form }) {
  return (
    <div className="user-registration">
      <UserRegistrationForm {...form} />
    </div>
  );
}

UserRegistration.propTypes = {
  form: FormActionShape.isRequired,
};

export default UserRegistration;
